import { Part } from "components/styles";
import UploadFileBlock from "../../../../components/UploadFileBlock/UploadFileBlock";

const ModifyFile = ({
    form,
    changeForm, 
    errors
}) => {
    //#region Functions
    const changeFileData = (newFile) => {
        changeForm({ ...newFile });
    }
    //#endregion
    return (
        <Part>
            <UploadFileBlock 
                title="Modifica tu archivo para poder continuar y finalizar tu carga masiva"
                changeForm={changeFileData}
                form={form}
                errors={errors}
            />
        </Part>
    );
}

export default ModifyFile;